import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  FormControlLabel,
  Checkbox,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  makeStyles,
  ImageList,
  ImageListItem,
  Typography,
} from "@material-ui/core";

import moment from 'moment';


import { SIREN_CONFIG } from "config.js";
import { connect, useSelector } from 'react-redux';
import firebase from '../../Firebase';
import {FallEventsTable} from "./FallEventsTable";
import { FormattedMessage, useIntl } from "react-intl";



const FirstAidUpdateForm = (props) => {
  const { className, user, history, emergencyInfo } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const facility_id = useSelector((store) => store.user.facility_id);

  const [itemData, setItemData] = useState([]);

  const handleSubmit = (event, values) => {
    event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/emergency/updateEmergencyInfo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        eventId: values.eventId,
        deviceId: values.deviceId, // 필수
        action : values.action,
        actionTimeStamp: values.actionTimeStamp,
        actionUser: values.actionUser
      }),
    })
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      if (responseData.resultCode === "000") {
        alert(formatMessage({id:'update_successful'}));

        setTimeout(() => {
          history.goBack();
        }, 500);
      } else {
        //에러
        console.log(responseData);
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
      }
    })
    .catch((error) => {
      console.error(error);
      alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
    });
      // .then((response) => {
      //   if (response.status == 200){
      //     // alert("업데이트에 성공했습니다.");
      //     alert(formatMessage({id:'update_successful'}));

      //     setTimeout(() => {
      //       history.goBack();
      //     }, 500);
      //   } else {
      //     alert(`업데이트에 실패했습니다.\n${responseData.resultMessage}`);
      //   }
      // });

  };


  const handleBack = () => {
    history.goBack();
  };


  useEffect(() => {

    var dbRef = firebase.database().ref('events').child( emergencyInfo.eventId ).child('files')

    dbRef.on('value', function(snapshot){
      let list = [];
      snapshot.forEach(function(childSnapshot){
        // list.push({ 'img': 'https://bighaveoffice-main.s3.ap-northeast-2.amazonaws.com/' + childSnapshot.val() });
        list.push({ 'img': 'https://ghsilver.s3.ap-northeast-2.amazonaws.com/' + childSnapshot.val() });
      });

      setItemData(list);
    });

  }, []);


  return (
    <div>
    <Formik
      initialValues={{
        deviceId: emergencyInfo.deviceId || "",
        eventId: emergencyInfo.eventId || "",
        roomName: emergencyInfo.roomName || "",
        installed_pos_detail: emergencyInfo.installed_pos_detail || "",
        first_eventTime: moment(emergencyInfo.first_eventTime).format('YY.MM.DD HH:mm') || "",
        lastStatus: emergencyInfo.lastStatus || "",
        action: emergencyInfo.action || "",
        actionTimeStamp: emergencyInfo.actionTimeStamp || moment().format('YY.MM.DD HH:mm'), //default로 현재시각
        actionUser: emergencyInfo.actionUser || user.admin_name, //로그인한 관리자 이름을 default로 표시
        // valid: emergencyInfo.flag === "1" ? true : false,
        // occurFrom: emergencyInfo.occurFrom === 1 ? "벡엔드" : "센서"
        isSentPush : emergencyInfo.isSentPush,
        occurFrom: emergencyInfo.occurFrom,
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.root, className)}
          onSubmit={(e) => handleSubmit(e, values)}
        >
          <Card>
            <CardHeader
              className={classes.card_header}
              title={formatMessage({id:'emergency_caution_action_title'})}
              titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }}
            />

            <Divider />

            <CardContent>
              <Grid container spacing={2}>

                <Grid container item md={12} xs={12} spacing={2}>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.eventId && errors.eventId)}
                      fullWidth
                      helperText={touched.eventId && errors.eventId}
                      label="ID"
                      name="ID"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.eventId}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                      disabled
                    />
                  </Grid>


                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.roomName && errors.roomName)}
                      fullWidth
                      helperText={touched.roomName && errors.roomName}
                      label={formatMessage({id:'room_name'})}
                      name="roomName"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.roomName}
                      variant="outlined"
                      inputProps={{ maxLength: 50 }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.installed_pos_detail && errors.installed_pos_detail)}
                      fullWidth
                      helperText={touched.installed_pos_detail && errors.installed_pos_detail}
                      label={formatMessage({id:'room_position'})}
                      name="installed_pos_detail"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.installed_pos_detail}
                      variant="outlined"
                      inputProps={{ maxLength: 50 }}
                      disabled
                    />
                  </Grid>

                </Grid>


                <Grid container item md={12} xs={12} spacing={2}>

                  <Grid item md={3} xs={12}>
                    <TextField
                      error={Boolean(touched.lastStatus && errors.lastStatus)}
                      fullWidth
                      helperText={touched.lastStatus && errors.lastStatus}
                      label={formatMessage({id:'emergency_history_status'})}
                      name="lastStatus"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.lastStatus}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                      disabled
                    />
                  </Grid>


                  <Grid item md={3} xs={12}>
                    <TextField
                      error={Boolean(touched.first_eventTime && errors.first_eventTime)}
                      fullWidth
                      helperText={touched.first_eventTime && errors.first_eventTime}
                      label={formatMessage({id:'isSentPush'})}
                      name="isSentPush"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.isSentPush}
                      variant="outlined"
                      inputProps={{ maxLength: 10 }}
                      disabled
                    />
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <TextField
                      error={Boolean(touched.isSentPush && errors.isSentPush)}
                      fullWidth
                      helperText={touched.isSentPush && errors.isSentPush}
                      label={formatMessage({id:'emergency_history_occurTime'})}
                      name="first_eventTime"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.first_eventTime}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                      disabled
                    />
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <TextField
                      error={Boolean(touched.occurFrom && errors.occurFrom)}
                      fullWidth
                      helperText={touched.occurFrom && errors.occurFrom}
                      label={formatMessage({id:'emergency_history_occurFrom'})}
                      name="occurFrom"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.occurFrom}
                      variant="outlined"
                      disabled
                    />
                  </Grid>

                </Grid>


                <Grid item md={12} xs={12}>
                  <TextField
                    error={Boolean(touched.action && errors.action)}
                    fullWidth
                    helperText={touched.action && errors.action}
                    // label="조치내용(최대100자)"
                    label={formatMessage({id:'emergency_history_action_100'})}
                    name="action"
                    multiline
                    rows={6}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // required
                    value={values.action}
                    variant="outlined"
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>


                <Grid container item md={12} xs={12} spacing={1}>

                  <Grid item md={6} xs={12}>
                    <TextField
                      error={Boolean(touched.actionTimeStamp && errors.actionTimeStamp)}
                      fullWidth
                      helperText={touched.actionTimeStamp && errors.actionTimeStamp}
                      label={formatMessage({id:'emergency_history_actionTime'})}
                      name="actionTimeStamp"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // required
                      value={values.actionTimeStamp}
                      variant="outlined"
                      inputProps={{ maxLength: 16 }}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      error={Boolean(touched.actionUser && errors.actionUser)}
                      fullWidth
                      helperText={touched.actionUser && errors.actionUser}
                      label={formatMessage({id:'emergency_history_actor'})}
                      name="actionUser"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // required
                      value={values.actionUser}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                    />
                  </Grid>

                </Grid>


                <Grid container item md={12} xs={12}
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    disabled={isSubmitting}
                    className={classes.action}
                  >
                    <FormattedMessage id="emergency_history_act_completed" />
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleBack}
                    className={classes.action}
                  >
                    <FormattedMessage id="cancel" />
                  </Button>
                </Grid>

              </Grid>

            </CardContent>

            <Divider className={classes.divider} variant="middle" />

            <Grid container spacing={1} >
              <Grid item md={3} xs={3}></Grid>
              <Grid item md={6} xs={6} style={{
                backgroundColor: "#eeeeee",
                marginTop: "20px",
              }}>
                <Typography
                  className={classes.dividerInset}
                  display="block"
                  variant="h5"
                  fullWidth
                  align="center"
                >
                  <FormattedMessage id="emergency_occur_position" />
                </Typography>
              </Grid>
              <Grid item md={3} xs={3}></Grid>

              <Grid item md={3} xs={3}></Grid>
              <Grid item md={6} xs={6}>
                <FallEventsTable eventId={emergencyInfo.eventId} />
              </Grid>
              <Grid item md={3} xs={3}></Grid>
            </Grid>


            <Divider className={classes.divider} variant="middle" />

            <CardHeader
              className={classes.card_header2}
              title={formatMessage({id:'emergency_snapshot_picture'})}
              titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4', }}
            />
            <CardContent>
              <ImageList sx={{width:600, height:450}} cols={6} rowHeight={180}>
                {itemData.map((item) => (
                  <ImageListItem key={item.img}>
                    <img src={`${item.img}?w=160&fit=crop&auto=format`}
                    srcSet={`${item.img}?w=320&fit=crop&auto=format&dpr=2 2x`}
                      alt={'Emergency'}
                      loading="lazy"
                      />
                  </ImageListItem>
                ))}
              </ImageList>
            </CardContent>

          </Card>
        </form>
      )}
    </Formik>
    </div>
  );
};

FirstAidUpdateForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


let mapStateToProps = (state) => {
  return {
    user: state.user
  };
}


export default connect(
  mapStateToProps
)(FirstAidUpdateForm);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  card_header2: {
    color: '#616161',
    backgroundColor: theme.palette.primary.contrastText,
  },

  divider: {
    marginTop: theme.spacing(1),
  },

  dividerInset: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: '#616161'
  },
}));
